
import global from '@/assets/js/global'
const data = {}
data.fzlcList = [
  {
    name: '2024-至今',
    version: '4.0',
    list: [
      { title: '承建“北疆民心桥”综合平台入选中国数字研究案例库' },
      { title: '数智社工综合服务平台上线' },
      { title: '全产品线深度融合DeepSeek，智驱场景升级' },
    ],
  },
  {
    name: '2021-2023',
    version: '3.0',
    list: [
      { title: '两代表一委员系统平台上线' },
      { title: '数字乡村系统平台上线' },
      { title: '防返贫检测系统平台上线' },
    ],
  },
  {
    name: '2017-2020',
    version: '2.0',
    list: [
      { title: '智慧人大系统平台上线' },
      { title: '智慧政协系统平台上线' },
      { title: '智慧党建系统平台上线' },
    ],
  },
  {
    name: '2010-2016',
    version: '1.0',
    list: [
      { title: '参与国家部委级信息安全规划' },
      { title: '连续多年参与国考护网服务' },
      { title: '参与多地公安系统防病毒检测服务' },
    ],
  },
]
data.collapseList = [
  {
    value: '1',
    name: '大客户销售经理',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: ' 负责公司核心产品重点行业客户开拓、维护；' },
      { title: '  负责开展与上游厂家的项目合作，挖掘客户资源；' },
      { title: ' 负责制定行业客户销售计划，执行策略；' },
      { title: ' 负责培训销售专员，做好转绑带工作。' },
    ],
    gwyqList: [
      { title: ' 熟悉行业客户运作流程，制定标准高效的销售策略并按计划执行；' },
      { title: '  熟悉信息化产品，包括信息安全产品，信息管控系统，交换存储设备；' },
      { title: '  能够根据客户需求做产品选型，制定相应产品方案；' },
      { title: '  有政府、金融、电信、能源等行业客户销售经验、成功案例。' },
    ]
  },
  {
    value: '2',
    name: '行业客户销售专员',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '按照公司的培训要求进行电话营销，根据负责的产品线通过电话方式开拓目标客户；' },
      { title: '独立或协同技术人员拜访目标客户，提交资料，讲解和演示产品功能，有效进行商务沟通；' },
      { title: '持续高效的跟进目客户，签订合约，达成交易；' },
      { title: '建立规范的客户文档、客户跟踪情况档案；' },
      { title: '制定详细客户回访计划，并按计划落实工作，做好售后服务工作，巩固客户关系。' },
    ],
    gwyqList: [
      { title: '具有良好的销售潜质，对销售有强烈的兴趣；' },
      { title: '具有顽强的销售精神，能够不折不扣的执行销售任务；' },
      { title: '具有良好的沟通技巧和商务谈判能力；' },
      { title: '具有良好的文字组织能力，能够快速高效的根据客户需求制定产品方案；' },
      { title: '具有良好的产品学习能力、接受能力，并学以致用。' },
    ]
  },
  {
    value: '3',
    name: '技术服务工程师',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '熟悉公司产品功能，协同销售人员完成与客户的售前技术交流；' },
      { title: '熟悉公司产品应用，能够独立完成产品安装、调试，确保产品正常运行；' },
      { title: '为客户提供产品日常运维及故障排除等相关服务，周期性为客户提供产品应用情况服务报告；' },
      { title: '汇总客户遇到的各类现场技术问题、解决办法、处理情况，及时反馈给销售部门。' },
    ],
    gwyqList: [
      { title: '通信、软件、计算机及相关专业毕业，熟悉计算机网络以及软件系统相关技术，能够解决各类常见问题；' },
      { title: '熟悉PPT制作、产品演示、解决方案等文档的设计写作；' },
      { title: '具有较强的工作责任心、学习能力、团队合作精神以及良好的沟通能力和服务意识。' },
    ]
  },
  {
    value: '4',
    name: '人力资源经理/专员',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '负责建立、健全公司人力资源管理系统，确保人力资源工作按照公司发展目标规范化；' },
      { title: '依据公司人力资源需求计划，组织招聘工作，收集招聘信息，进行人员招聘、选拔及聘用；' },
      { title: '帮助建立积极的员工关系，协调员工与管理层的关系，组织策划员工的各类活动；' },
      { title: '协助上级推行公司各类规章制度的实施；' },
      { title: '拟定公司规章制度，负责员工日常纪律、考勤、绩效考核工作。' },
    ],
    gwyqList: [
      { title: '有人力资源项目规划和实施经验；' },
      { title: '熟悉人力资源管理各项实务的操作流程；' },
      { title: '熟悉使用相关办公软件；' },
      { title: '办事沉稳、细致，思维活跃，有创新精神，良好的团队合作意识；' },
      { title: '优秀的品行和行业素质，强烈的敬业精神与责任感，工作原则性强。' },
    ]
  },
  {
    value: '5',
    name: '市场部经理',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '负责产品和市场策划：进行市场调研分析，定位营销、提炼卖点，制定产品和市场方案；' },
      { title: '负责市场策略的研究、策划、组织与实施，对公司营销战略和策略及时进行调整；' },
      { title: '负责完善市场体系管理制度与执行流程。' },
    ],
    gwyqList: [
      { title: '产品和市场策划能力俱佳、思路清晰、文笔优异，公关能力强，能独立运作、策划项目；' },
      { title: '具有创意灵感和策划天赋，曾取得骄人的产品和市场策划业绩，有一定的团队管理经验。' },
    ]
  },
  {
    value: '6',
    name: '战略合作部经理',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '负责制定战略合作部的工作流程规范、部门发展战略规划及相关规章制度；' },
      { title: '严格落实客户调研，分析目标客户需求，正确做出市场销售预测，拟定年度渠道销售计划、预算，分解目标及预算，制定具体战略合作推广方案，并能严格地督导与执行。' },
    ],
    gwyqList: [
      { title: '能够根据公司的任务，制定出部门业务目标，并带领团队实现既定销售目标；' },
      { title: '具备良好的营销与管理素养，文笔良好，能够带领大客户业务加速规范运营；' },
      { title: ' 可以制定部门规范的运营流程，具有敏锐的商业触觉、优异的工作业绩。' },
    ]
  },
  {
    value: '7',
    name: '网络推广部经理/专员',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '推广网站推广计划，开展网盟、微博、论坛等多元推广方式，持续提升网站流量；' },
      { title: '搜集信息，丰富网站内容，增加有效传播；' },
      { title: '定期提交推广情况报告，有效规避有偿推广风险。' },
    ],
    gwyqList: [
      { title: '计算机或者电子商务大专以上学历；' },
      { title: '熟悉网站开发、应用常规流程；' },
      { title: '熟悉网络营销策略，能够独立制定有效的网络推广方案并付诸实施，实现收益；' },
      { title: '熟悉互联网环境，能够独立开展横向合作。' },
    ]
  },
  {
    value: '8',
    name: '网站开发工程师',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '参与需求调研、项目可行性分析、技术可行性分析和需求分析；' },
      { title: '根据需求分析和系统框架完成系统的详细设计；' },
      { title: '负责基于ASP/ASP.NET+SQL Server的B/S架构的网站程序及系统开发的编写实现工作；' },
      { title: '对开发程序进行单元测试，集成测试；并负责解决开发过程中的技术问题；' },
      { title: '负责网站或信息系统的安装，布署，调试等维护工作。' },
    ],
    gwyqList: [
      { title: '掌握C#编程，熟悉Framework2.0框架及Ajax，掌握VS.NET2005及以上版本开发环境；' },
      { title: '熟练掌握至少一门数据库语言SQL SERVER/MYSQL/ORACLE等；' },
      { title: '掌握CSS+DIV，对网站布局有一定认识，熟悉javascript和jquery等前端技术；' },
      { title: '一年以上web开发经验，能独立承担大型动态网站前后台程序的设计与开发工作，能完成较复杂的网站功能，曾开发过商城、行业网、团购网者优先；' },
      { title: '熟悉windows2003服务器的维护及IIS6.0的配置，具备独立网站调试及部署能力；' },
      { title: '有良好的代码编写习惯和文档编写能力；团队合作精神、交流和沟通能力强。' },
    ]
  },
  {
    value: '9',
    name: '网页设计师',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '负责设计商业网站的页面；' },
      { title: '负责日常专题性质栏目设计。' },
    ],
    gwyqList: [
      { title: '美术或计算机专业，具有扎实的美工功底；' },
      { title: '熟练使用Photoshop、Fireworks、Dreamweaver、Flash等常用工具进行网页制作；' },
      { title: '熟练手写HTML代码css样式，熟练运用DIV+CSS设计制作网页，能与程序人员默契配合；' },
      { title: '能够独立完成网页动画，包括FLASH动画、网络宣传及FLASH等相关设计工作；' },
      { title: '对色调和线条有独特的见解和创意，熟悉各种网站构造、色调；' },
      { title: '有独立优秀的设计理念，具有独立完成工作的能力；' },
      { title: '对网站开发有浓厚的兴趣，有良好的职业情操，能够适应高强度的工作，自信稳重，有责任感，有良好的沟通能力以及团 队协作精神；' },
      { title: '至少1年商业网站设计经验者，申请人请提供作品或网址。' },
    ]
  },
  {
    value: '10',
    name: '财务出纳',
    address: '北京/郑州/西安/呼和浩特/乌鲁木齐/广州/南宁',
    email: 'jinqiruanjian@126.com',
    gwmsList: [
      { title: '按照公司现金管理制度，办理现金收付业务，登记现金日记账，做到日清月结；' },
      { title: '管理银行账户，保管和签发支票，办理银行收付业务，及时准确登记银行日记账；' },
      { title: '每月定期与银行对账，编制银行存款余额调节表，做好每月报税和工资的发放工作；' },
      { title: '负责日常报销工作，整理和装订凭证。' },
    ],
    gwyqList: [
      { title: '会计专业毕业，具备一年以上出纳或会计工作经验，熟悉会计基础理论知识，并能灵活运用，并熟悉国家有关财经法规及税务法规；' },
      { title: '有会计证，熟练操作办公软件。' },
    ]
  },
]
data.contactUsList = [
  { title: '北京锦润万泽科技有限公司', phone: '010-81791910', mobilePhone: '13718880969', name: '符经理' },
  { title: '锦润科技-河南办事处', phone: '010-81791910', mobilePhone: '15003992828', name: '靳经理' },
  { title: '锦润科技-陕西办事处', phone: '010-81791910', mobilePhone: '18729206679', name: '曹经理' },
  { title: '锦润科技-广东办事处', phone: '010-81791910', mobilePhone: '15322269665', name: '靳经理' },
]
export default {
  data
}
